// extracted by mini-css-extract-plugin
export default {"layout":"label-notification_layout__cSoYO","label":"label-notification_label__ivfmC","link":"label-notification_link__FXFm0","notification":"label-notification_notification__8Nvyn"};